import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react'; // @ts-expect-error Legacy code isn't typed

import FormattedDuration from 'I18n/components/FormattedDuration';
import I18n from 'I18n';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { parseNumericValue } from '../utils/parseNumericValue';

const PropertyInputReadOnlyDuration = ({
  value,
  className
}) => {
  const numericValue = parseNumericValue(value);

  if (numericValue === null) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: EMPTY_PROPERTY_VALUE
    });
  }

  return /*#__PURE__*/_jsx(UIGridItem, {
    size: {
      xs: 12
    },
    className: `p-x-0 ${className}`,
    children: /*#__PURE__*/_jsx(FormattedDuration, {
      from: I18n.moment().valueOf() - numericValue
    })
  });
};

export default /*#__PURE__*/memo(PropertyInputReadOnlyDuration);